import {
  CONVENIO_FILTER_ALL,
  Convenio,
  ConvenioFilter,
  Transfer,
  TransferStatus,
} from './types'
import { getDateFromString } from 'utilities/date.util'
import { BadgeTone } from 'components/ui/statusBadge'

export type TransferStatusMeta = {
  title: string
  /** Completes "Baixar repasses ..." for the status. */
  downloadSuffix: string
  description?: string
  color: string
  tone: BadgeTone
}

export const TRANSFER_STATUS_META: Record<TransferStatus, TransferStatusMeta> = {
  [TransferStatus.PENDENTE]: {
    title: 'Contas a receber',
    downloadSuffix: 'pendentes',
    description: 'Aguardando pagamento dos convênios e/ou cartão de créditos.',
    color: '#E8A317',
    tone: 'warning',
  },
  [TransferStatus.GLOSADO]: {
    title: 'Glosado',
    downloadSuffix: 'glosados',
    description: 'Sem possibilidade de recebimento.',
    color: '#C44536',
    tone: 'danger',
  },
  [TransferStatus.PROCESSANDO]: {
    title: 'Fila de pagamento',
    downloadSuffix: 'na fila de pagamento',
    description: 'Valor já recebido do convênio e aguardando liberação do repasse.',
    color: '#3BA8C4',
    tone: 'info',
  },
  [TransferStatus.LIBERADO]: {
    title: 'Próximo pagamento',
    downloadSuffix: 'do próximo pagamento',
    color: '#2B7FD4',
    tone: 'primary',
  },
  [TransferStatus.PAGO]: {
    title: 'Pago',
    downloadSuffix: 'pagos',
    color: '#2A9F6B',
    tone: 'success',
  },
}

/** Order of the status cards on screen. */
export const STATUS_CARD_ORDER: TransferStatus[] = [
  TransferStatus.PENDENTE,
  TransferStatus.GLOSADO,
  TransferStatus.PROCESSANDO,
  TransferStatus.LIBERADO,
  TransferStatus.PAGO,
]

/** Priority used to pick which status is selected after loading. */
export const STATUS_SELECTION_ORDER: TransferStatus[] = [
  TransferStatus.PAGO,
  TransferStatus.LIBERADO,
  TransferStatus.PROCESSANDO,
  TransferStatus.PENDENTE,
  TransferStatus.GLOSADO,
]

export const getStatusMeta = (status: string): TransferStatusMeta | undefined =>
  TRANSFER_STATUS_META[status as TransferStatus]

export const matchesConvenioFilter = (
  transfer: Transfer,
  convenio: ConvenioFilter
) =>
  convenio === CONVENIO_FILTER_ALL ||
  (convenio === Convenio.SUS
    ? transfer.convenio === Convenio.SUS
    : transfer.convenio !== Convenio.SUS)

export const compareByDataProcedimento = (a: Transfer, b: Transfer) =>
  getDateFromString(b.dataProcedimento).getTime() -
  getDateFromString(a.dataProcedimento).getTime()

export const getProcedureDescription = (transfer: Transfer) =>
  transfer.descricaoProcedimento !== null
    ? transfer.descricaoProcedimento
    : transfer.observacaoRepasse
